import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, BookOpen, Sparkles } from 'lucide-react';
export function SystemIntro() {
  return <section className="py-20 px-4 bg-mystic-900 relative" data-id="element-239">
      <div className="max-w-4xl mx-auto text-center" data-id="element-240">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold-500/10 text-gold-400 font-medium mb-6" data-id="element-241">
          <Trophy className="w-5 h-5" data-id="element-242" />
          <span data-id="element-243">El Sistema N°1 para Mujeres</span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-3xl md:text-5xl font-serif font-bold text-white mb-8" data-id="element-244">
          que quieren dejar de atraer vínculos fríos
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-mystic-800/50 border border-mystic-700 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-245">
          <div className="absolute top-0 right-0 w-64 h-64 bg-lilac-500/10 rounded-full blur-3xl" data-id="element-246" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-gold-500/5 rounded-full blur-3xl" data-id="element-247" />

          <div className="relative z-10" data-id="element-248">
            <h3 className="text-2xl md:text-3xl font-bold text-gold-400 mb-2" data-id="element-249">
              EL CÓDIGO DEL MAGNETISMO — Colección Completa
            </h3>
            <p className="text-xl text-lilac-300 font-medium mb-8" data-id="element-250">
              12 Tomos + 6 Bonus + 2 Élite
            </p>

            <p className="text-2xl font-serif text-white italic mb-10" data-id="element-251">
              Todo resuelto. Todos los patrones. Todos los dolores.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-252">
              <div className="flex items-center gap-3 bg-mystic-900/50 p-4 rounded-xl border border-mystic-700/50" data-id="element-253">
                <BookOpen className="w-6 h-6 text-lilac-400 flex-shrink-0" data-id="element-254" />
                <span className="text-slate-200 font-medium" data-id="element-255">+280 páginas</span>
              </div>
              <div className="flex items-center gap-3 bg-mystic-900/50 p-4 rounded-xl border border-mystic-700/50" data-id="element-256">
                <Sparkles className="w-6 h-6 text-gold-400 flex-shrink-0" data-id="element-257" />
                <span className="text-slate-200 font-medium" data-id="element-258">
                  +100 ejercicios, rituales, tests y protocolos
                </span>
              </div>
            </div>

            <div className="mt-6 text-slate-400 text-sm md:text-base tracking-wide uppercase" data-id="element-259">
              Astrología · Energía · Psicología vincular · Reprogramación
              subconsciente
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}